


































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { Validator } from "vee-validate";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import FileUpload from "vue-upload-component";
import { useNotifierStore } from "@/shared/store/notifier";
import { useRiskQuizScoreStore } from "@/admin/store/riskQuizScore";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { UserPermission } from "@/shared/types";

@Component({
  components: {
    FileUpload,
    GenericLoadingSpinner,
  }
})
export default class RiskQuizAgePortfolios extends Vue {
  $validator: Validator;
  file = null;
  isSubmitting = false;

  notifierStore = useNotifierStore();
  riskQuizScoreStore = useRiskQuizScoreStore();
  rolePermissionsStore = useRolePermissionsStore();

  created () {
    this.riskQuizScoreStore.loadRiskQuizAgePortfolios();
  }

  get isLoading () {
    return this.riskQuizScoreStore.isLoadingRiskQuizAgePortfolioFetchState;
  }

  tableHeadings = [
    {
      key: "age",
      label: "Age",
      thClass: "text-left",
    },
    {
      key: "wlpId",
      label: "WLP ID",
      thClass: "text-left",
    },
    {
      key: "clientId",
      label: "Client ID",
      thClass: "text-left",
    },
    {
      key: "portfolioId",
      label: "Portfolio ID",
      thClass: "text-left",
    },
    {
      key: "name",
      label: "Portfolio Name",
      thClass: "text-left",
    }
  ];

  get tableFields () {
    return this.riskQuizScoreStore.didLoadRiskQuizAgePortfolioFetchState ? this.riskQuizScoreStore.riskQuizAgePortfolios : [];
  }
  get submitDisabled () {
    return this.isSubmitting || !this.file;
  }
  fileChange (file) {
    if (!file) return;
    this.file = (document.getElementById("file-asset") as any).files[0];
  }
  get fileNameDisplay (): string {
    return this.file ? this.file.name : "Click to select .csv file";
  }

  get hasEditPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityDrvWealthRiskAgePortEdit);
  }
  submit () {
    if (!this.file) return;
    if (this.isSubmitting) return;

    this.isSubmitting = true;

    this.riskQuizScoreStore.processRiskQuizAgePortfolioFile({
      csv: this.file
    })
      .then(() => {
        this.notifierStore.setSuccess("Risk Quiz Portfolio Ages have been processed");
        this.riskQuizScoreStore.loadRiskQuizAgePortfolios();
      }).catch(() => null)
      .finally(() => {
        this.isSubmitting = false;
        this.file = null;
      });
  }
}
